<template>
  <div>
    <div class="d-flex justify-content-center" v-if="carregando">
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </div>

    <div class="row" v-if="!existeCadastro && !carregando">
      <div class="col-4">Essa conta não possui configurações de CRM:</div>
      <div class="col-2">
        <template>
          <modal-criar-conta
            :idConta="conta.id"
            @conta-criada="contaCriada"
          ></modal-criar-conta>
        </template>
      </div>
    </div>

    <b-form ref="frmCrm" v-if="existeCadastro && !carregando">
      <div class="row">
        <div class="col-1">
          <b-form-group>
            <label>CRM ID<span class="text-danger">*</span>:</label>
            <b-form-input
              name="crmId"
              disabled
              v-model="frmCrm.crmId"
              data-inputmask="'alias': 'integer'"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-3">
          <b-form-group>
            <label>Token de acesso<span class="text-danger">*</span>:</label>
            <b-form-input
              name="token"
              disabled
              v-model="frmCrm.token"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-8">
          <b-form-group>
            <div class="col-7">
              <label>Qtd. Máx. de Usuários:</label>
            </div>
            <div class="col-2">
              <b-form-input
                name="qtdMaxUsuarios"
                v-model="frmCrm.qtdMaxUsuarios"
                type="number"
              ></b-form-input>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-1">
          <label>Chat ID:</label>
          <b-form-input
            name="idChatwoot"
            v-model="frmCrm.idChatwoot"
            type="number"
          ></b-form-input>
        </div>
        <div class="col-3">
          <label>ID da caixa de entrada:</label>
          <b-form-input
            name="idCaixaEntrada"
            v-model="frmCrm.idCaixaEntrada"
            type="number"
          ></b-form-input>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";

import Inputmask from "inputmask";
import ModalCriarConta from "./crm/ModalCriarConta";

export default {
  props: {
    conta: Object
  },

  data() {
    return {
      frmCrm: {
        crmId: "",
        token: "",
        idConta: "",
        qtdMaxUsuarios: "",
        idCaixaEntrada: "",
        idChatwoot: ""
      },
      carregando: true,
      existeCadastro: false
    };
  },

  components: { ModalCriarConta },

  mounted() {
    this.abrir();
  },

  methods: {
    abrir() {
      const self = this;

      ApiService.post("conta/obter-configuracao-crm", {
        idConta: this.conta.id
      })
        .then((response) => {
          const configuracao = response.data.data;

          if (!configuracao) {
            this.existeCadastro = false;
            this.carregando = false;
            return;
          }

          this.frmCrm.idConta = this.conta.id;
          if (configuracao) {
            this.frmCrm.crmId = configuracao.crmId;
            this.frmCrm.token = configuracao.token;
            this.frmCrm.qtdMaxUsuarios = configuracao.qtdMaxUsuarios;
            this.frmCrm.idCaixaEntrada = configuracao.idCaixaEntrada;
            this.frmCrm.idChatwoot = configuracao.idChatwoot;
            this.existeCadastro = true;
          }

          this.carregando = false;
        })
        .then(function () {
          self.validacao();

          self.$watch(
            "frmCrm",
            function () {
              self.$emit("aba-alterada", true);
            },
            { deep: true }
          );
        });
    },

    validacao() {
      const frmCrm = this.$refs["frmCrm"];
      const self = this;

      Inputmask().mask(frmCrm.querySelectorAll("input"));

      this.fv = formValidation(frmCrm, {
        fields: {
          crmId: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          },
          token: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          },
          qtdMaxUsuarios: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap()
        }
      });
    },

    salvar() {
      return this.fv.validate().then((status) => {
        if (status == "Valid") {
          ApiService.post("conta/atualizar-configuracao-crm", this.frmCrm)
            .then(() => {
              this.$emit("aba-alterada", false);

              Swal.fire({
                title: "MENSAGEM",
                text: "Atualizado com sucesso!",
                icon: "success",
                heightAuto: false
              });
            })
            .catch(() => {
              for (const error in this.validatorErrors) {
                this.fv
                  .updateValidatorOption(
                    error,
                    "blank",
                    "message",
                    this.validatorErrors[error]
                  )
                  .updateFieldStatus(error, "Invalid", "blank");
              }
            });
        }
      });
    },

    contaCriada(conta) {
      this.frmCrm.crmId = conta.crm_id;
      this.frmCrm.idConta = conta.idConta;
      this.frmCrm.token = conta.token;
      this.frmCrm.qtdMaxUsuarios = conta.qtdMaxUsuarios;
      this.frmCrm.idCaixaEntrada = conta.idCaixaEntrada;
      this.frmCrm.idChatwoot = conta.idChatwoot;
      this.$emit("aba-alterada", false);
    }
  }
};
</script>
